export const NOTIFICATION_TYPE = {
  CHINESE_BELL: "chineseBell",
};
